module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.show_landing) ? _c('div', {
    staticClass: "main-wrap",
    staticStyle: {
      "background-color": "#fafafa"
    },
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.header_data
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pager",
    staticStyle: {
      "background-color": "none",
      "margin-top": "6em",
      "text-align": "left"
    },
    attrs: {
      "id": "topPageWrap"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "background-color": "none"
    }
  }, [_c('div', {
    key: _vm.componentKey,
    staticClass: "card card-box"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "addCategory"
    }
  }, [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "padding-right": "1em"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('addCategory')
      }
    }
  }, [_vm._v("X CLOSE  ")]), _vm._v(" "), _c('component-add-category')], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "addProduct"
    }
  }, [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "padding-right": "1em"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('addProduct')
      }
    }
  }, [_vm._v("X CLOSE  ")]), _vm._v(" "), _c('component-add-product')], 1), _vm._v(" "), _c('div', {
    staticClass: "card-head"
  }, [_c('h4', [_c('span', [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "padding-right": "1em"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Categories  ")])]), _vm._v("|\r\n              "), _c('span', [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "padding-left": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('products')
      }
    }
  }, [_vm._v("Products")])])])]), _vm._v(" "), (_vm.loading) ? _c('div', [_vm._m(0)]) : _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "2em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [(_vm.menu_tab_inner_view['product']) ? _c('div', {
    staticStyle: {
      "margin-bottom": "8em"
    }
  }, [_c('div', [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding-right": "1em"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("X BACK  ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('p', [_vm._v("Product Name")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.set_product.product_name))]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('p', [_vm._v("Product Price")]), _vm._v(" "), _c('h3', [_c('span', {
    staticClass: "sm-x"
  }, [_vm._v("₦‎" + _vm._s(_vm.set_product.product_items[0].product_item_price_f))])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('p', [_vm._v("Product Photos")]), _vm._v(" "), _vm._l((_vm.set_product.product_images), function(im) {
    return _c('div', {
      staticClass: "col-xs-3"
    }, [_c('div', {
      staticStyle: {
        "width": "56px",
        "height": "60px"
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": im.product_image
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr')], 2), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('p', [_vm._v("Description")]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.set_product.product_description))])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {}, [_c('h4', [_vm._v("Add to more categories")]), _vm._v(" "), _vm._l((_vm.product_categories), function(cat) {
    return (cat.category_id != _vm.category.category_id) ? _c('div', {
      key: cat.catgory_id
    }, [_c('p', [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.setAddProductToMultipleCategories(cat)
        }
      }
    }), _vm._v("  " + _vm._s(cat.category_name))])]) : _vm._e()
  }), _vm._v(" "), _c('div', [(_vm.data_error_message != '') ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddProductToMoreCategories(_vm.set_product, 1)
      }
    }
  }, [_vm._v("ADD")])])], 2), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {}, [_c('h4', [_vm._v("Delete product")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "prDConfrm"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Delete Product ?")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "background": "#ff0000",
      "color": "#fafafa"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.deleteProduct(_vm.set_product)
      }
    }
  }, [_vm._v("Yes, Delete")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#1a73da"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message)), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "promptPrDConfrm"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "background": "#ff0000",
      "color": "#fafafa"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleDoubleComponent('prDConfrm', 'promptPrDConfrm')
      }
    }
  }, [_vm._v("Delete")])])])])])]) : (_vm.menu_tab_inner_view['category_products']) ? _c('div', [_c('h3', [_vm._v("Products in " + _vm._s(_vm.category.category_name) + " Category")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setCategory();
      }
    }
  }, [_vm._v("Add new Product")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('h6', [_vm._v("Total Products (" + _vm._s(_vm.products.length) + ")")]), _vm._v(" "), _c('table', _vm._l((_vm.products), function(product, index) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s((index + 1)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "95%"
      }
    }, [_c('div', {
      staticClass: "col-xs-3"
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.set_product = product;
          _vm.setMenuTabInnerView('product')
        }
      }
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9"
    }, [_c('p', [_c('b', [_vm._v("Name")]), _c('br'), _vm._v("\r\n                          " + _vm._s(product.product_name) + "\r\n                        ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Price")]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x"
    }, [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Description")]), _c('br'), _vm._v("\r\n                          " + _vm._s(product.product_description) + "\r\n                        ")])]), _vm._v(" "), _c('hr')])])
  }))])]) : (_vm.menu_tab_inner_view['products']) ? _c('div', [_c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('addProduct')
      }
    }
  }, [_vm._v("Add new Product")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('h6', [_vm._v("Total Products (" + _vm._s(_vm.products.length) + ")")]), _vm._v(" "), _c('table', _vm._l((_vm.products), function(product, index) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s((index + 1)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "95%"
      }
    }, [_c('div', {
      staticClass: "col-xs-3"
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9"
    }, [_c('p', [_c('b', [_vm._v("Name")]), _c('br'), _vm._v("\r\n                          " + _vm._s(product.product_name) + "\r\n                        ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Price")]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x"
    }, [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Description")]), _c('br'), _vm._v("\r\n                          " + _vm._s(product.product_description) + "\r\n                        ")])]), _vm._v(" "), _c('hr')])])
  }))])]) : _c('div', [_c('div', [_c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('addCategory');
      }
    }
  }, [_vm._v("Add new Category")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.product_categories && (Object.keys(_vm.product_categories).length > 0)) ? _c('div', {
    key: _vm.componentKey
  }, [_c('div', _vm._l((_vm.product_categories), function(set_category, index) {
    return _c('div', {
      key: index,
      staticClass: "card"
    }, [_c('p', [_c('a', {
      staticClass: "btn sp-button-02-lt",
      on: {
        "click": function($event) {
          _vm.category = set_category;
          _vm.getProductCategoryProducts();
          _vm.setMenuTabInnerView('category_products')
        }
      }
    }, [_vm._v(_vm._s(set_category.category_name))])]), _vm._v(" "), _c('hr')])
  }))]) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No categories yet")])])])])])])])])]) : _c('div', [_c('component-landing')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e246139"}!./src/pages/Timeline/template.html
// module id = 538
// module chunks = 0